import Vue from 'vue'
import App from './App'
import { router } from './router'
import VueCropper from 'vue-cropper'
// import VueI18n from 'vue-i18n'
// import vantLocal from './lang/vantLocal'
import huaDesignLocal from './lang/huaDesignLocal'

import messages from './lang/i18n'
import moment from 'moment'
// import FastClick from 'fastclick'

Vue.prototype.$moment = moment
const language = localStorage.getItem('language') || navigator.language || navigator.browserLanguage

// Vue.use(VueI18n)
// const i18n = new VueI18n({
//     locale: language, // set locale
//     messages, // set locale messages
//     silentTranslationWarn: true,
// })

moment.locale(language)

//VUE全局设置localStorage完整代码
if (window.navigator.userAgent.indexOf('dhb') !== -1) {
    window.addEventListener('dhbready', async () => {
        let plugin = await DhbPlugin('dhb/plugin/messagehandle')
        if (plugin) {
            //native插入成功了，开始渲染页面
            plugin.registerHandler('loadLocalstorageFinish', function () {
                /* eslint-disable no-new */
                new Vue({
                    router,
                    el: '#app',
                    // i18n,
                    render: h => h(App)
                })
                return "success"
            })
            // 通知native 插入token
            plugin.callHandler('loadLocalstorage', 'para', (message) => {
                console.log(1)
            })
        }
    })
} else {
    /* eslint-disable no-new */
    new Vue({
        router,
        el: '#app',
        // i18n,
        render: h => h(App)
    })

}
// FastClick.attach(document.body)
Vue.use(VueCropper)
// vantLocal(language)
// huaDesignLocal(language)
